var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87393 5.09878C9.15651 2.10098 12.1318 0 15.6 0C20.2392 0 24 3.76081 24 8.4C24 10.8879 22.9169 13.1244 21.2003 14.6608C20.7065 15.1028 19.9478 15.0608 19.5058 14.567C19.0638 14.0731 19.1059 13.3145 19.5997 12.8725C20.8291 11.7721 21.6 10.1769 21.6 8.4C21.6 5.08629 18.9137 2.4 15.6 2.4C12.7589 2.4 10.3764 4.37586 9.75691 7.02972C9.6683 7.40934 9.40081 7.72226 9.0396 7.86886C8.67839 8.01546 8.26848 7.97747 7.94037 7.76698C7.38109 7.40819 6.71669 7.2 6 7.2C4.01178 7.2 2.4 8.81178 2.4 10.8C2.4 12.131 3.1217 13.2949 4.20087 13.9191C4.77454 14.251 4.97058 14.985 4.63873 15.5587C4.30688 16.1324 3.5728 16.3284 2.99913 15.9966C1.20886 14.961 0 13.0224 0 10.8C0 7.48629 2.68629 4.8 6 4.8C6.65358 4.8 7.28376 4.90488 7.87393 5.09878Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24853 18.3515C8.7799 17.8828 8.0201 17.8828 7.55147 18.3515C7.08284 18.8201 7.08284 19.5799 7.55147 20.0485L11.1515 23.6485C11.3849 23.8819 11.6905 23.9991 11.9964 24L12 24L12.0036 24C12.165 23.9995 12.3189 23.9672 12.4593 23.9089C12.6009 23.8504 12.7335 23.7636 12.8485 23.6485L16.4485 20.0485C16.9172 19.5799 16.9172 18.8201 16.4485 18.3515C15.9799 17.8828 15.2201 17.8828 14.7515 18.3515L13.2 19.9029V13.2C13.2 12.5373 12.6627 12 12 12C11.3373 12 10.8 12.5373 10.8 13.2V19.9029L9.24853 18.3515Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFile);
export default __webpack_public_path__ + "static/media/download-file.c8695f1738461139bf1900667df829a6.svg";
export { ForwardRef as ReactComponent };